import { useTranslation } from 'react-i18next';
import { PublicPageShell } from '../widgets/public-page-shell/public-page-shell';
import { Button, Container } from '../shared/ui';

/**
 * Адрес, которого нет в роутере: опечатка в ссылке, лишний сегмент после
 * `/p/<pointId>/`, устаревшая ссылка из рассылки. Без этой страницы роутер
 * показывал голый текст «Not Found» на белом фоне — без шапки и дороги назад.
 */
export function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <PublicPageShell>
      <Container className="flex flex-col items-center gap-6 py-16 text-center sm:py-24">
        <h1 className="text-text-primary text-3xl font-semibold leading-tight sm:text-4xl">
          {t('notFound.title')}
        </h1>
        <p className="text-text-tertiary max-w-xl text-base leading-6 sm:text-lg">
          {t('notFound.description')}
        </p>
        <Button href="/" className="w-full sm:w-auto">
          {t('notFound.home')}
        </Button>
      </Container>
    </PublicPageShell>
  );
}
